import request from '@/utils/request'
//退货入库

//获取经办人下拉
export function getRkStatus() {
  return request({
    method: 'get',
    url: "/yzdservice/api/enum/rk/ty"
  })
}
//选择退货出库单号
export function getThckXgxx() {
    return request({
      method: 'get',
      url: "/yzdservice/enterprise/dwCk/thrk/getThckXgxx"
    })
}
//获取经办人下拉
export function getLyrList() {
  return request({
    method: 'get',
    url: "/yzdservice/enterprise/dwCk/syck/getLyrList"
  })
}
//获取退货入库列表
export function getThrkList(data) {
    return request({
      method: 'post',
      url: "/yzdservice/enterprise/dwCk/thrk/list",
      data:data
    })
}

//新增/编辑保存退货入库（暂时保存）
export function addOrUpdSaveTemp(data) {
  return request({
    method: 'post',
    url: "/yzdservice/enterprise/dwCk/thrk/addOrUpdSaveTemp",
    data:data
  })
}

//新增/编辑保存退货入库（入库）
export function addOrUpdSave(data) {
  return request({
    method: 'post',
    url: "/yzdservice/enterprise/dwCk/thrk/addOrUpdSave",
    data:data
  })
}
//获取退货入库详情
export function getThrkdetail(id) {
  return request({
    method: 'get',
    url: "/yzdservice/enterprise/dwCk/thrk/detail/"+id
  })
}
//删除退货入库
export function deleteThrk(id) {
  return request({
      method: 'delete',
      url: "/yzdservice/enterprise/dwCk/thrk/remove/"+id
  })
}
//退货入库导出
export function excelwriter(data) {
  return request({
      method: 'post',
      url: "/yzdservice/enterprise/dwCk/thrk/excelwriter",
      data:data,
      responseType: 'blob'
  })
}
//变更保存前校验是否为负数
export function changePdkcByThrk(data) {
  return request({
      method: 'post',
      url: "/yzdservice/enterprise/dwCk/thrk/changePdkcByThrk",
      data:data
  })
}
//变更退货入库
export function saveChangeApply(data) {
  return request({
      method: 'post',
      url: "/yzdservice/enterprise/dwCk/thrk/saveChangeApply",
      data:data
  })
}
